import { Avatar } from '@creditornot/cb-avatar';
import { colors, cbSemanticCssVars, typographyClassName } from '@creditornot/cb-ingredients';
import { Spinner } from '@creditornot/cb-progress';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import { Tag } from '@creditornot/cb-tag';
import React from 'react';
import styled from 'styled-components';

export const Content = styled.div`
  width: 300px;
  padding-block: 16px;

  @media (width <= 400px) {
    min-width: 100%;
  }
`;

export const StyledLoader = styled.div`
  padding-block-start: 8px;
  padding-inline: 16px;
  display: flex;
  justify-content: center;
`;

export const Loader = () => (
  <StyledLoader>
    <Spinner size="medium" />
  </StyledLoader>
);

export const SectionHeader = styled.div`
  padding-block: 18px;
  font-size: 12px;
  line-height: 16px;
  color: ${cbSemanticCssVars.textSecondary};

  &:first-of-type {
    padding-block-start: 0;
  }
`;

export const ResultsContainer = styled.div`
  max-height: 300px;
  overflow-y: scroll;
  margin-block-start: 18px;
  padding-inline: 16px;
`;

export const ListItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SearchWrapper = styled.div`
  position: relative;
  margin-inline: 16px;
`;

export const CurrentText = styled.span`
  display: flex;
  align-items: center;
  min-width: 80px;
  margin-inline-end: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: -0.154px;

  @media (width <= 640px) {
    flex-direction: column;
  }
`;

export const ActiveResultTag = styled(Tag).attrs({
  variant: 'outlineBlack',
  size: 'tiny',
  uppercase: true,
})`
  margin-inline-start: 12px;
  @media (width <= 640px) {
    display: none;
  }
`;

export const SearchItemSelectorButtonContainer = styled.div`
  position: relative;
  font-size: 15px;
  display: flex;
  align-items: center;

  @media (width <= 400px) {
    justify-content: center;
  }
`;

export const Title = styled.div`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (width <= 640px) {
    display: block;
    line-height: 1.43;
    font-size: 14px;
  }
`;

export const Subtitle = styled.div`
  display: inline-block;
  margin-inline-start: 4px;
  overflow: hidden;
  text-overflow: ellipsis;

  ::before {
    content: '(';
  }

  ::after {
    content: ')';
  }

  @media (width <= 640px) {
    display: block;
    margin-inline-start: 0;
    line-height: 1.33;
    color: rgb(32 33 37 / 60%);
    font-weight: normal;
    font-size: 12px;

    ::before,
    ::after {
      display: none;
    }
  }
`;

export const SelectorContainer = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
`;

export const InformationContainer = styled.div`
  width: 100%;
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const AvatarTagSearchContainer = styled.div<{ isCollapsed?: Boolean }>`
  display: flex;
  justify-content: ${({ isCollapsed }) => (isCollapsed ? 'center' : 'space-between')};
`;

export const AddressAndTagContainer = styled.div`
  width: 100%;
  color: ${cbSemanticCssVars.textSecondary};
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const EntityTitle = styled.span.attrs({ className: typographyClassName.Body3SemiBold })`
  line-height: 20px;
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const AvatarTagContainer = styled.div<{ isCollapsed?: Boolean }>`
  display: flex;
  gap: ${({ isCollapsed }) => (isCollapsed ? 0 : '8px')};
  align-items: center;
`;

export const AvatarContainer = styled.div`
  border-radius: 50%;
  position: relative;
`;

export const EntityAvatar = styled(Avatar)`
  cursor: pointer;

  img {
    object-fit: cover;
  }
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TagContainer = styled.div`
  margin-block-start: 2px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px;
`;

export const StatusLightBackground = styled.div`
  position: absolute;
  bottom: 1px;
  right: 1px;
  background-color: ${cssThemedValue({ light: colors.salt100, dark: colors.salt100 })};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 14px;
  width: 14px;
  border-radius: 50%;
`;

export const PopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 188px;
`;

export const PopoverTitle = styled.span.attrs({ className: typographyClassName.Body3Bold })``;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  ${SelectorContainer}:hover & {
    background-color: ${cbSemanticCssVars.surfaceMain};
  }
`;
